<template>
  <div>
    <div
      class="rounded-lg justify-between items-center rounded-lg mb-4"
      style="
        background-image: url(https://cdn.discordapp.com/attachments/733851758211629347/954057924391600218/BG.png);
        box-shadow: rgb(0 0 0 / 10%) 0px 4px 25px 0px;
      "
    >
      <div class="flex justify-between items-center rounded-lg p-4" style="backdrop-filter: blur(10px)">
        <div class="flex items-center">
          <img
            alt="examedge"
            draggable="false"
            src="https://connect-cdn.intellectualpoint.com/assets/images/apps/TestPrepIcon.png"
            class="rounded hidden sm:block mr-5"
            style="width: 75px"
          />
          <div>
            <h1 class="font-bold">ExamEdge Selector</h1>
            <h5 class="font-light">{{ selectorData.assignments.length }} Total Assignments</h5>
          </div>
        </div>

        <div class="flex items-center"></div>
      </div>
    </div>

    <div class="vx-row" v-if="courseData && selectorData">
      <div :class="selectorData.assignments && selectorData.assignments.length > 0 ? 'vx-col w-7/12' : 'vx-col w-full'">
        <h1 class="font-bold mb-4">Practice Exam Configurator</h1>

        <div class="flex items-center gap-3 mb-8">
          <vx-card>
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-4">
                <img v-if="courseData.thumbnail" :src="courseData.thumbnail" class="rounded-lg" width="75px" />
                <div>
                  <h5 class="font-light text-white">{{ selectorData.questions }} Total Questions</h5>
                  <h1 class="text-white font-bold">{{ courseData.name }}</h1>
                </div>
              </div>
              <vs-button @click="$router.push('/courses')" type="gradient">Change Course</vs-button>
            </div>
          </vx-card>
        </div>

        <h2 class="font-light mb-3">Exam Mode</h2>
        <div class="flex justify-between items-center gap-4 mb-8">
          <vx-card
            class="card-hover-mode cursor-pointer border border-success"
            :class="`${modeSelected === 'study' ? ' border-solid' : ''}`"
            @click="
              modeSelected = 'study';
              shuffle = false;
            "
          >
            <div class="flex items-center gap-4">
              <img
                src="https://cdn.discordapp.com/attachments/746242308084858900/1147015024653635624/book-and-brain.png"
                class="rounded-lg"
                width="75px"
              />
              <div>
                <h1 class="text-white">Study Mode</h1>
                <h5 class="font-light text-white">Can reveal answers and read explanations as you go with no time limit</h5>
              </div>
            </div>
          </vx-card>
          <vx-card
            class="card-hover-mode cursor-pointer flex items-center gap-4 border border-success"
            @click="
              modeSelected = 'test';
              shuffle = true;
            "
            :class="`${modeSelected === 'test' ? ' border-solid' : ''}`"
          >
            <div class="flex items-center gap-4">
              <img
                src="https://cdn.discordapp.com/attachments/746242308084858900/1147015599143272458/exam-result.png"
                class="rounded-lg"
                width="75px"
              />
              <div>
                <h1 class="text-white">Test Mode</h1>
                <h5 class="font-light text-white">Must complete all questions in one sitting and can only review at the end.</h5>
              </div>
            </div>
          </vx-card>
        </div>

        <h2 class="font-light mb-3">Range Configuration</h2>
        <div class="flex justify-items-auto items-center gap-6 popup-input no-number-btn mb-8">
          <div>
            <p>Range Start</p>
            <vs-input-number v-model="rangeStart" type="number" min="1" :max="selectorData.questions" />
          </div>
          <div>
            <p>Range End</p>
            <vs-input-number hide-spin-buttons v-model="rangeEnd" type="number" min="1" :max="selectorData.questions" />
          </div>
          <div class="">
            <p class="mb-3">Shuffle</p>
            <vs-switch v-model="shuffle" class="border border-solid border-white mb-3" />
          </div>
          <div class="w-full ml-2 pl-2">
            <p>Number of Questions</p>
            <div class="flex items-center gap-6">
              <p>1</p>
              <vs-slider :max="rangeEnd - rangeStart + 1" v-model="numberOfQuestions" />
              <p>{{ rangeEnd - rangeStart + 1 }}</p>
            </div>
          </div>
        </div>

        <div class="mb-4">
          <h2 class="font-light mb-3">Quiz Timer</h2>
          <div class="flex items-center mb-4">
            <vs-radio
              v-model="timer.length"
              color="white"
              :vs-value="0"
              vs-name="timer"
              class="mr-3 p-2 font-bold rounded-lg bg-primary-gradient"
              @input="timer.custom = false"
              >No Timer
            </vs-radio>
            <vs-radio
              v-model="timer.length"
              color="white"
              :vs-value="15"
              vs-name="timer"
              class="mr-3 p-2 font-bold rounded-lg bg-primary-gradient"
              @input="timer.custom = false"
              >15 Min
            </vs-radio>
            <vs-radio
              v-model="timer.length"
              color="white"
              :vs-value="30"
              vs-name="timer"
              class="mr-3 p-2 font-bold rounded-lg bg-primary-gradient"
              @input="timer.custom = false"
              >30 Min
            </vs-radio>
            <vs-radio
              v-model="timer.length"
              color="white"
              :vs-value="45"
              vs-name="timer"
              class="mr-3 p-2 font-bold rounded-lg bg-primary-gradient"
              @input="timer.custom = false"
              >45 Min
            </vs-radio>
            <vs-radio
              v-model="timer.length"
              color="white"
              :vs-value="60"
              vs-name="timer"
              class="mr-3 p-2 font-bold rounded-lg bg-primary-gradient"
              @input="timer.custom = false"
              >1 Hrs
            </vs-radio>
            <vs-radio
              v-model="timer.length"
              color="white"
              :vs-value="120"
              vs-name="timer"
              class="mr-3 p-2 font-bold rounded-lg bg-primary-gradient"
              @input="timer.custom = false"
              >2 Hrs
            </vs-radio>
            <vs-radio
              v-model="timer.custom"
              color="white"
              :vs-value="true"
              vs-name="timer"
              class="mr-3 p-2 font-bold rounded-lg bg-primary-gradient"
              >Custom Duration
            </vs-radio>
          </div>
          <div v-if="timer.custom">
            <h5 class="mb-1 font-light">Enter Custom Time (In Minutes)</h5>
            <div class="flex items-center mb-4">
              <vs-input-number
                class="bg-primary-gradient font-bold"
                :min="1"
                :max="720"
                :max-decimal="0"
                size="large"
                v-model="timer.length"
              />
            </div>
          </div>
        </div>

        <vs-button type="gradient" @click="generateQuiz(null)">Generate Quiz</vs-button>
      </div>
      <div v-if="selectorData.assignments && selectorData.assignments.length > 0" class="vx-col w-5/12">
        <h1 class="font-bold mb-4">Compliance Assignments</h1>
        <div class="mb-6 p-6 rounded-lg" style="background-color: rgba(0, 0, 0, 0.15)">
          <div class="grid grid-cols-sets gap-5">
            <div v-for="(assignment, index) in selectorData.assignments" :key="index" class="flex items-center justify-center">
              <set-card
                  :id="assignment.id"
                  :name="assignment.name"
                  :description="assignment.description"
                  :thumbnail="assignment.thumbnail"
                  :percent="assignment.progress.percent || 0"
                  :completed="assignment.progress.passed || false"
                  :terms_completed="assignment.progress.questions_correct || 0"
                  :terms_count="assignment.progress.questions ? assignment.progress.questions.length : 0"
                  :range_start="assignment.range_start"
                  :range_end="assignment.range_end"
                  :timer="assignment.timer"
                  :questions="assignment.questions"
                  :mode="assignment.mode"
                  :min_score="assignment.min_score"
                  v-on:generateQuiz="generateQuiz(assignment)"
              />

            </div>
          </div>
        </div>
      </div>
      <!---
     <div class="vx-col w-full">
        <div v-for="(domain, dIndex) in selectorData" :key="dIndex">
          <div class="flex justify-between mb-1 p-2">
            <h2 class="font-light">{{ domain.name }}</h2>
            <h2 class="font-light">{{ domain.sets.length }} Sets</h2>
          </div>
          <div class="mb-6 p-6 rounded-lg" style="background-color: rgba(0, 0, 0, 0.15)">
            <div class="grid grid-cols-sets gap-5">
              <div v-for="(set, index) in domain.sets" :key="index" class="flex items-center justify-center">
                <set-card
                  :id="set.id"
                  :name="set.name"
                  :thumbnail="set.thumbnail"
                  :percent="set.percent"
                  :terms_completed="set.terms_completed"
                  :terms_count="set.terms_count"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
  -->
    </div>
    <div v-else class="simple-spinner">
      <span></span>
    </div>
  </div>
</template>

<script>
import LottieAnimation from '../../../../components/lottie/LottieAnimation'
import SetCard from './components/TestPrepSetCard'

export default {
  data () {
    return {
      courseData: null,
      selectorData: null,

      modeSelected: 'study',

      shuffle: false,
      rangeStart: 1,
      rangeEnd: 1,
      numberOfQuestions: 0,

      timer: {
        custom: false,
        popup: false,
        length: 0,
        display: null
      }
    }
  },
  computed: {
    setColorProgress () {
      const theme = this.$store.state.theme
      if (theme === 'light') return 'rgba(0,0,0,0.2)'
      if (theme === 'dusk') return 'rgba(0,0,0,0.5)'
      if (theme === 'dark') return 'rgba(0,0,0,0.2)'
    },
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    }
  },
  components: {
    SetCard,
    LottieAnimation
  },
  methods: {
    generateQuiz (assignment = null) {
      const pl = assignment
        ? { assignment: assignment.id }
        : {
          type: this.modeSelected,
          shuffle: this.shuffle,
          questions: this.numberOfQuestions,
          range_start: parseInt(this.rangeStart),
          range_end: parseInt(this.rangeEnd),
          timer: this.timer.length || null
        }

      this.$http
        .post('app/testprep/generate', pl)
        .then((response) => {
          if (response.status === 200) {
            this.$router.push({
              path: `/examedge/${response.data.data.quiz.id}/play`
            })
          }
        })
        .catch(() => {
          this.testPrepStartError()
        })
    },
    testPrepStartError () {
      this.$vs.notify({
        title: 'Error While Generating Quiz',
        text: 'There was an error generating your quiz, try again.',
        icon: 'feather',
        iconPack: 'icon-x-circle',
        color: 'danger',
        position: 'top-right'
      })
    },
    fetchCourseDetails (id) {
      if (this.activeCourseInfo.selected === false) {
        this.$vs.notify({
          title: 'No Course Selected',
          text: 'Please select a courses before practicing',
          color: 'danger',
          position: 'top-right'
        })
        return this.$router.push('/courses')
      }

      this.$http
        .get(`courses/${id}`)
        .then((response) => {
          if (response.status === 200) {
            this.courseData = response.data.data
            this.fetchSelectorData(id)
          }
        })
        .catch(() => {})
    },
    fetchSelectorData () {
      this.$http
        .get('app/testprep/selector')
        .then((response) => {
          if (response.status === 200) {
            console.log(response)
            this.selectorData = response.data.data
            this.rangeEnd = this.selectorData.questions
            this.numberOfQuestions = this.selectorData.questions
          }
        })
        .catch(() => {})
    },
    lottiePlay (ref) {
      this.$refs[ref][0].play()
    },
    lottieStop (ref) {
      this.$refs[ref][0].stop()
    }
  },
  created () {
    this.fetchCourseDetails(this.activeCourseInfo.id)

    setTimeout(() => {
      this.currentStep = 1
    }, 1500)
  },
  beforeDestroy () {
    this.courseData = null
    this.selectorData = null
  }
}
</script>

<style>
.card-hover-mode {
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>
